document.addEventListener('DOMContentLoaded', () => {
  const scrollNavigation = document.querySelector('.designers-nav');
  const arrowLeft = document.querySelector('.left');
  const arrowRight = document.querySelector('.right');

  function scrollContent(direction) {
    const scrollAmount = scrollNavigation.clientWidth / 2;
    scrollNavigation.scrollLeft += direction * scrollAmount;
    toggleArrowButton();
  }

  function toggleArrowButton() {
    const isAtEnd =
      Math.round(scrollNavigation.scrollLeft) >= scrollNavigation.scrollWidth - scrollNavigation.clientWidth;
    const isAtStart = scrollNavigation.scrollLeft === 0;

    arrowRight.classList.toggle('hide', isAtEnd);
    arrowLeft.classList.toggle('hide', isAtStart);
  }

  arrowLeft.addEventListener('click', () => scrollContent(-1));
  arrowRight.addEventListener('click', () => scrollContent(1));
  toggleArrowButton();
});

// 追従ナビの高さはアンカーの --anchor-offset に要る。
// 折り返しと画面幅で変わるため固定値にできず、実測して CSS へ渡す
document.addEventListener('DOMContentLoaded', () => {
  const stickyNav = document.querySelector('.scroll-designers-nav');
  const scope = stickyNav?.closest('.shopify-section');
  if (!scope) return;

  let lastHeight = -1;

  const publishHeight = (height) => {
    const rounded = Math.round(height);
    // ResizeObserver のループ防止
    if (rounded === lastHeight) return;

    lastHeight = rounded;
    scope.style.setProperty('--_designers-nav-height', `${rounded}px`);
  };

  // CSS 側の既定値に頼る時間を作らないよう、監視の前に一度だけ実測しておく
  publishHeight(stickyNav.getBoundingClientRect().height);

  new ResizeObserver(([entry]) => {
    // contentRect は padding を含まず 2rem 足りない。Focal と同じく clientHeight を代替にする
    publishHeight(entry.borderBoxSize?.[0]?.blockSize ?? entry.target.clientHeight);
  }).observe(stickyNav);
});
